define('gameday-index-url-hasher/querySyntax',['require','exports','module'],function(require,exports,module){
	return function(){
		return module.config() === true ? '&' : ',';
	}
});
